// @flow
import React, {Component, Fragment} from 'react';
import environment from '../../../environment';
import {Base64} from 'js-base64';
import queryString from 'query-string';

import style from './Scrap.scss';

import type {Location as RouterLocation} from '../../../router';
import type {User} from '../../../entities';

export type Props = {
  +user?: User;
  +location?: RouterLocation;
  +handleOpenAuthModal: (openLoginView?: boolean) => void;
  +goToRedirect: (route: string) => void;
};

export type State = {
  url: string;
  initialized: boolean;
};

export default class Scrap extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const { location } = props;
    const parsedQuery = queryString.parse(location.search);

    this.state = {
      url: parsedQuery.initialQuery,
      initialized: false,
    };
  }

  componentDidMount() {
    this.setState((st: State) => ({
      initialized: true,
    }));

    window.addEventListener('message', this.handleReceiveMessage);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleReceiveMessage);
  }

  handleReceiveMessage = (message) => {
    const {user, handleOpenAuthModal, goToRedirect} = this.props;
    const qsp = document.querySelector('#qempo-scrap-pages');

    if (!qsp || !qsp.contentWindow) return;

    // console.log('[handleReceiveMessage]', message.origin, message)

    if (message.origin !== 'https://pages.dev.qempo.io' && message.origin !== 'https://pages.qempo.io') {
      // console.log('[handleReceiveMessage] skip');
      return;
    }

    if (!!message.data) {

      if (message.data.event === 'SCRAPING') {
        console.log('[handleReceiveMessage]', message.data.event, message.data);
        qsp.style.height = `${message.data.data.scrollHeight}px`;
        window.scrollTo(0, 0);
      } else if (message.data.event === 'FINISHED_SCRAP') {
        qsp.style.height = `${message.data.data.scrollHeight}px`;
      } else if (message.data.event === 'ADD_TO_SHOPPING_CART') {
        const b64 = Base64.encode(JSON.stringify(message.data.data));
        goToRedirect(`/new-order/product?preferred_importation_method=full&preferred_full=FAST&action=CART&product=${b64}`);
      } else if (message.data.event === 'BUY_NOW') {
        const b64 = Base64.encode(JSON.stringify(message.data.data));
        goToRedirect(`/new-order/product?preferred_importation_method=full&preferred_full=FAST&action=BUY_NOW&product=${b64}`);
      }
    }
  }

  render() {
    const {initialized, url} = this.state;
    
    return (
      <Fragment>
        {initialized && (
          <iframe id="qempo-scrap-pages"
                  className={style.newScrap}
                  scrolling="no"
                  src={`${environment.qempoIoPagesUrl}/product/mix/scrap/mix?url=${encodeURIComponent(url)}`}
                  frameBorder="0" />
            )
        }
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/scrap/components/Scrap.jsx